<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="smalltitle">License & Credentials</div>
            <i>Your uploaded license and credential files.</i>

            <div class="currentlist">
                <p class="no-file" v-if="listFiles.length === 0">No file</p>
                <ul class="itemlisttable providerlist" v-if="listFiles.length > 0">
                    <li class="itemlisthead">
                        <div class="col-type">TYPE</div>
                        <div class="col-lic-number">LIC. NUMBER</div>
                        <div class="col-expiration">EXPIRATION</div>
                        <div class="col-state">STATE</div>
                        <div class="col-main">MAIN</div>
                        <div class="col-clinic">CLINIC NAME</div>
                        <div class="col-files">UPLOADED FILES</div>
                    </li>
                    <li v-for="item in listFiles" :key="item.type_number">
                        <div class="col-type">{{ getTypeFile(item) }}</div>
                        <div class="col-lic-number">{{ item.type_number }}</div>
                        <div class="col-expiration">{{ formatTime(item.expiration_date) }}</div>
                        <div class="col-state">{{ item.state }}</div>
                        <div class="col-main">
                            <i class="fas fa-check-circle"
                               v-if="item.type !== 'abai_copy' && item.type !== 'abai' && item.main_number">
                            </i>
                        </div>
                        <div class="col-clinic">{{ item.clinic_name }}</div>
                        <div class="col-files" :title="item.file_name">{{ item.file_name }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import httpClient from '../../../../client'

export default {
  name: 'TabLicense',
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      listFiles: []
    }
  },
  mounted () {
    this.getListFiles()
  },
  methods: {
    getTypeFile (item) {
      if (item.type === 'medical_license') return 'Medical License'
      if (item.type === 'dea') return 'DEA'
      if (item.type === 'abai' || item.type === 'abai_copy') return 'ABAI'
      return item.type
    },
    async getListFiles () {
      try {
        let response = await httpClient.get('/users/electronic-medical-wiki', { params: { userId: this.userInfo.id } })
        if (response.data.s === 200) {
          this.listFiles = response.data.data.files
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>

<style scoped>
.no-file {
    text-align: center;
}
.col-type      { width: 13% !important; }
.col-lic-number { width: 12% !important; text-align: center; }
.col-expiration { width: 14% !important; text-align: center; }
.col-state     { width: 7%  !important; text-align: center; }
.col-main      { width: 8%  !important; text-align: center; }
.col-clinic    { width: 22% !important; text-align: left; }
.col-files     { width: 24% !important; text-align: center; }
</style>
